import {
  GET_ACCOUNT_STATUS,
  TRANSITION_ACCOUNT,
  GET_STATUS_HISTORY,
  GET_ACCOUNT_SUBSCRIPTIONS,
  GET_ACCOUNT_ENTITLEMENTS,
  LIST_LIFECYCLE_PLANS,
} from '../lib/constant';

const initialState = {
  accountStatus: null,
  transitionResult: null,
  statusHistory: null,
  accountSubscriptions: null,
  accountEntitlements: null,
  lifecyclePlans: null,
};

export default function (state = initialState, action) {
  switch (action.type) {
    case GET_ACCOUNT_STATUS:
      return { ...state, accountStatus: action.payload };
    case TRANSITION_ACCOUNT:
      return { ...state, transitionResult: action.payload };
    case GET_STATUS_HISTORY:
      return { ...state, statusHistory: action.payload };
    case GET_ACCOUNT_SUBSCRIPTIONS:
      return { ...state, accountSubscriptions: action.payload };
    case GET_ACCOUNT_ENTITLEMENTS:
      return { ...state, accountEntitlements: action.payload };
    case LIST_LIFECYCLE_PLANS:
      return { ...state, lifecyclePlans: action.payload };
    default:
      return state;
  }
}
